import React, { Component } from 'react';
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import AnchorLink from 'components/common/AnchorLink';
import InlineCollapsible from 'components/common/InlineCollapsible';
import Paragraphs from 'components/common/Paragraphs';

class AboutDetail extends Component {
	constructor(props) {
		super(props);
		this.state = {
			topazLeungIsOpen: false,
			martinCheungIsOpen: false,
		};
	}
	showProfile = (e) => {
		e.preventDefault();
		switch (e.target.getAttribute('href')) {
			case '#about-topaz-leung':
				this.setState({ topazLeungIsOpen: true });
				break;
			case '#about-martin-cheung':
				this.setState({ martinCheungIsOpen: true });
				break;
			default:
				break;
		}
	}
	render() {
		return (
			<div id="AboutDetail">
				<div id="AboutDetail-intro">
					<section className="Columns">
						<main>
							<p>Studio TM is an <AnchorLink href="#About-awards">award-winning</AnchorLink> creative studio in Hong Kong founded in 2010 by two creative talents <AnchorLink href="#about-topaz-leung" onClick={this.showProfile}>Topaz Leung</AnchorLink> and <AnchorLink href="#about-martin-cheung" onClick={this.showProfile}>Martin Cheung</AnchorLink>, focusing photography, advertising, art direction and art education.</p>
						</main>
						<aside>
							<Paragraphs text={this.props.contact} />
						</aside>
					</section>
				</div>

				<div id="about-topaz-leung">
					<Collapsible trigger="Topaz Leung" transitionTime={this.props.collapsible_speed} open={this.state.topazLeungIsOpen}>
						<section className="Columns">
							<main>
								<p>earned her reputation as a commercial photographer from years of solid experience working with top-tier brands and creative agencies. She is also the recipient of several local and oversea remarkable awards.<sup>1</sup></p>
							</main>
							<aside>
								<ol>
									<li>Awards including:<br />Young Design Talent Award from Hong Kong Design Centre in 2011, Asia of Surface Asia Avant Guardian Award in 2012, and New Generation Asian Photographers in Japanese Magazine ‘+81’ in 2013
									</li>
								</ol>
							</aside>
						</section>
					</Collapsible>
				</div>

				<div id="about-martin-cheung">
					<Collapsible trigger="Martin Cheung" transitionTime={this.props.collapsible_speed} open={this.state.martinCheungIsOpen}>
						<section className="Columns">
							<main>
								<p>with a background of fine arts, is a photographer particularly seasoned in pinhole photography. His exceptional craftsmanship brought him the honor of joining Berlin DMY design exhibition in 2010. He received excellent review on his solo and group exhibitions.<sup>2</sup></p>
							</main>
							<aside>
								<ol start="2">
									<li>Solo and group exhibitions include Tokyo design week, ‘Where the light gets in’ at MUJI Atelier in 2011, and a pinhole container installation at West Kowloon in 2012.</li>
								</ol>
							</aside>
						</section>
					</Collapsible>
				</div>

				<section className="Columns">
					<main>
						<p>Topaz and Martin held several remarkable <InlineCollapsible transitionTime={10} trigger="Exhibitions" plain="They held their first ever exhibition ‘REALITY’ in 2015 at Gallery 27. They have also joined ‘Twin Peaks: Contemporary Hong Kong Photography’ at Hong Kong Heritage Museum in 2014 and ‘Affordable Art Fair’ in 2016 and more,">They held their first ever exhibition ‘REALITY’ in 2015 at Gallery 27. They have also joined ‘Twin Peaks: Contemporary Hong Kong Photography’ at Hong Kong Heritage Museum in 2014 and ‘Affordable Art Fair’ in 2016 and <AnchorLink href="#About-exhibitions">more</AnchorLink>, </InlineCollapsible>and are seen in some local and overseas <AnchorLink href="#About-press">Press</AnchorLink>.
						</p>
						<p>As much as Studio TM plans to grow their presence in industry, they are also concerned with art and cultural issues to expand their impact beyond photography.</p>
					</main>
					<aside></aside>
				</section>
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		collapsible_speed: state.config.collapsible_speed,
	}
}

export default connect( mapStateToProps )(AboutDetail);



// WEBPACK FOOTER //
// ./src/components/Pages/About/AboutDetail.jsx